import { render } from "./ModalEditarUnicoSelecionado.vue?vue&type=template&id=098e1dbc&scoped=true&ts=true"
import script from "./ModalEditarUnicoSelecionado.vue?vue&type=script&lang=ts"
export * from "./ModalEditarUnicoSelecionado.vue?vue&type=script&lang=ts"

import "./ModalEditarUnicoSelecionado.vue?vue&type=style&index=0&id=098e1dbc&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098e1dbc"]])

export default __exports__